export const USAGE_WDRP = 'WDRP'
export const USAGE_ERRP = 'ERRP'
export const USAGE_IRTPC = 'IRTPC'
export const USAGE_WAP = 'WAP'
export const USAGE_VALUES = [USAGE_WDRP, USAGE_ERRP, USAGE_IRTPC, USAGE_WAP]
export const USAGE_DEFAULT_VALUE = USAGE_WDRP
